module.exports = __webpack_public_path__ + "assets/webgl/Assets_4_base_color.jpg.etc.dd7d6c5f.ktx";